<template>
  <v-tooltip
    bottom
    color="grey lighten-2"
    v-model="showErrorMessage"
    v-bind="{ disabled: !showErrorMessage }"
  >
    <v-btn
      class="mx-0"
      slot="activator"
      round
      small
      :disabled="isRunning"
      v-on="{ click: isStar ? callDeleteStar : callAddStar }"
      data-star-button
      style="text-transform: none !important;"
    >
      <v-icon class="pr-1" v-bind="{ color: isStar ? '#FFC000' : '' }" small>
        fas fa-star
      </v-icon>
      <span class="pr-1">{{ this.isDummy ? "***" : starredCountStr }}</span>
      {{ lang.button_text }}
    </v-btn>
    <span class="black--text">{{ errorMessage }}</span>
  </v-tooltip>
</template>

<script>
import qs from "qs";
import ice from "../../../lib/ice";

export default {
  name: "vc-share-star-button",
  props: {
    locale: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          button_text: "お気に入り",
          failed_contents_stars: "「お気に入り」に失敗しました",
          failed_contents_stars_release: "「お気に入り」の解除に失敗しました"
        };
      }
    },
    initialStarredCount: {
      type: Number,
      default: 0
    },
    initialStarState: {
      type: Boolean,
      default: false
    },
    isDummy: {
      type: Boolean,
      default: false
    },
    identificationCode: {
      type: String,
      default: ""
    },
    identificationCodeHash: {
      type: String,
      default: ""
    },
    postStar: {
      type: Function,
      default: () => {}
    },
    deleteStar: {
      type: Function,
      default: () => {}
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    contentsUrl: {
      type: String,
      default: ""
    },
    href: {
      type: String,
      default: ""
    },
    isWall: {
      type: Boolean,
      default: false
    },
    isMyWall: {
      type: Boolean,
      default: false
    },
    isStarredPage: {
      type: Boolean,
      default: false
    },
    loginUrl: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      isStar: this.initialStarState,
      starredCount: this.initialStarredCount,
      starredCountStr: "",
      showErrorMessage: false,
      errorMessage: "",
      setHref: "",
      isRunning: false
    };
  },
  mounted: function() {
    const { scrollto } = qs.parse(window.location.search.replace("?", ""));

    if (scrollto === "star") {
      if (history.replaceState !== undefined && history.state !== undefined) {
        // noinspection JSCheckFunctionSignatures : this.contentsUrlがstringと判定されないため抑制
        history.replaceState(null, null, this.contentsUrl);
      }

      this.$vuetify.goTo("[data-star-button]", { offset: -70 });
      setTimeout(() => {
        this.isStar ? this.callDeleteStar() : this.callAddStar();
      }, 1000);
    }
    if (!this.isStar) {
      this.setHref = this.href;
    }
    this.starredCountStr = parseInt(this.starredCount).toLocaleString(
      this.locale
    );
  },
  methods: {
    callAddStar: function() {
      if (!this.isLoggedIn) {
        top.location.href = this.loginUrl;
        return;
      }

      this.isRunning = true;

      this.isStar = true;
      this.starredCount++;
      this.starredCountStr = parseInt(this.starredCount).toLocaleString(
        this.locale
      );

      let requestData = {
        identificationCode: this.identificationCode,
        identificationCodeHash: this.identificationCodeHash
      };

      this.postStar(requestData).then(value => {
        if (value !== 0) {
          this.isStar = false;
          this.starredCount--;
          this.starredCountStr = parseInt(this.starredCount).toLocaleString(
            this.locale
          );
          this.showErrorMessage = true;
          this.errorMessage = this.lang.failed_contents_stars;
          this.hideErrorMessage();
          return;
        }

        if (ice.isIce()) {
          window.open(this.setHref, "_blank");
        } else {
          if (this.isWall === false) {
            top.location.href = this.setHref;
            return;
          }
        }

        this.isRunning = false;
      });
    },
    callDeleteStar: function() {
      this.isRunning = true;

      this.isStar = false;
      this.setHref = this.href;
      if (this.starredCount > 0) {
        this.starredCount--;
      } else {
        this.starredCount = 0;
      }
      this.starredCountStr = parseInt(this.starredCount).toLocaleString(
        this.locale
      );

      let requestData = {
        identificationCode: this.identificationCode
      };

      this.deleteStar(requestData).then(value => {
        if (value !== 0) {
          this.isStar = true;
          this.starredCount++;
          this.starredCountStr = parseInt(this.starredCount).toLocaleString(
            this.locale
          );
          this.showErrorMessage = true;
          this.errorMessage = this.lang.failed_contents_stars_release;
          this.hideErrorMessage();
          return;
        }

        if (this.isMyWall) {
          let url = location.origin;
          if (this.isStarredPage) {
            top.location.href = url + top.location.pathname;
            return;
          }

          const { code } = qs.parse(window.location.search.replace("?", ""));
          if (code !== "") {
            location.href = url + location.pathname + "?code=" + code;
            return;
          }

          window.location.reload();
          return;
        }

        if (this.isWall) {
          window.location.reload();
          return;
        }

        this.isRunning = false;
      });
    },
    hideErrorMessage() {
      setTimeout(() => {
        this.showErrorMessage = false;
      }, 10000);
    }
  }
};
</script>
